export const Services = {
  ADMIN: {
    path: process.env.REACT_APP_ADMIN,
    method: "",
    descrp: "API TO HANDLE ADMIN",
  },
  MAIL: {
    path: process.env.REACT_APP_MAIL,
    method: "",
    descrp: "API TO HANDLE MAIL",
  },
  BI: {
    path: process.env.REACT_APP_BI,
    method: "POST",
    descrp: "UPLOAD SATO FILE",
  },
  DASHBOARD: {
    path: process.env.REACT_APP_DASHBOARD,
    method: "",
    descrp: "API DASHBOARD",
  },
  RSS: {
    path: process.env.REACT_APP_RSS,
    method: "",
    descrp: "API TO HANDLE RSS",
  },
  AUDIT: {
    path: process.env.REACT_APP_AUDIT,
    method: "POST",
    descrp: "AUDIT LOGIN, MODULE",
  },
  Get_QuickSearch: {
    path: process.env.REACT_APP_TRACEABILITY,
    method: "GET",
    descrp: "method to list results of quick search",
  },
  DOWNLOAD: {
    path: process.env.REACT_APP_DOWNLOAD,
    method: "GET",
    descrp: "Download files",
  },
  TRACEABILITY: {
    path: process.env.REACT_APP_TRACEABILITY,
    method: "",
    descrp: "API TO HANDLE TRACEABILITY",
  },
  REPORTS: {
    path: process.env.REACT_APP_REPORTS,
    method: "",
    descrp: "API TO HANDLE REPORTS",
  },
};
